import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ProfilesStyles } from './Style';
import { ProfilesContext } from './ProfilesContext';
import { Chip } from 'components/Form';
import BlurredText from 'components/BlurredText';
import { abilityGroups } from 'keys';
import { ratingIcons, ratingTexts2 } from 'keys/rating'; // הוסר ratingText (לא היה בשימוש)

/**
 * קומפוננטת Profiles
 * * מציגה רשימה של כרטיסיות תלמידים מקובצים לפי רמות דירוג (Ratings), 
 * ספציפית עבור קבוצת היכולת של שטף קריאה (FLUENCY).
 * מסננת את התצוגה בהתאם לדירוגים שנבחרו (visibleRatings) ומתחשבת במצב תצוגה מוסתרת (brokenDisplay).
 */
const Profiles = () => {
    // שליפת סטייט גלובלי מ-Redux
    const { brokenDisplay } = useSelector(state => state.general);

    // שליפת נתונים וסינונים מה-Context המקומי של העמוד
    const { profiles: profilesRes, visibleRatings, showDetails } = useContext(ProfilesContext);

    // הגנה: יצירת אובייקט ריק כברירת מחדל אם הנתונים טרם נטענו
    const profiles = profilesRes?.data || {};

    return (
        <ProfilesStyles>
            {/* שימוש ב-Object.entries למעבר נקי גם על המפתח וגם על הערך */}
            {Object.entries(profiles).map(([ratingKey, profileData]) => {
                
                // 1. אם הדירוג כובה בפילטר, לא נרנדר אותו
                if (!visibleRatings[ratingKey]) return null;

                // 2. חילוץ הנתונים הספציפיים עבור קבוצת היכולת FLUENCY
                const fluencyData = profileData?.[abilityGroups.FLUENCY.key];
                
                // 3. אם אין תלמידים/נתונים בקבוצה זו, נדלג על הרינדור
                if (!fluencyData) return null;

                // חישוב אינדקס בטוח עבור מערכי האייקונים והצבעים 
                // מחשב את האינדקס לפי הדירוג עצמו ("1" -> 0) ולא לפי אינדקס הלולאה
                const styleIndex = parseInt(ratingKey, 10) - 1;

                return (
                    <div key={`rating-section-${ratingKey}`} className='profile-section'>
                        
                        {/* כותרת וסיכום נתונים של הדירוג */}
                        <div className='profile-header'>
                            <div className='profile-title'>
                                <i 
                                    className={`${ratingIcons[styleIndex]}`} 
                                    style={{ color: ratingTexts2[styleIndex] }} 
                                />
                                <div>{`דירוג ${ratingKey}`}</div>
                            </div>
                            
                            <div 
                                style={{ color: ratingTexts2[styleIndex] }} 
                                // className={brokenDisplay ? 'blurred2' : ''}
                            >
                                {/* שימוש בערכי ברירת מחדל (0) במידה ואין נתונים */}
                                <BlurredText>{fluencyData.count || 0}</BlurredText>
                                {` תלמידים`}
                                {` | ${fluencyData.percentage ? fluencyData.percentage.toFixed() : 0}% מהתלמידים המוצגים`}
                            </div>
                        </div>
                        
                        {/* כרטיסיות התלמידים עצמם */}
                        <div className='profile-content-cards overflow'>
                            {fluencyData.students?.map((student) => (
                                <div key={student.id} className='profile-content-card'>
                                    <div className={`profile-content-card-item ${brokenDisplay ? 'blurred2' : ''}`}>
                                        
                                        <Chip color={`rating${ratingKey}`}>
                                            {student.name}
                                            {/* הצגת פרטים נוספים (כיתה) רק אם התבקש ויש נתון */}
                                            {showDetails && student.school_class ? `, ${student.school_class}` : ''}
                                        </Chip>

                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                );
            })}
        </ProfilesStyles>
    );
}

export default Profiles;